import { Tolgee, DevTools, BackendFetch, LanguageStorage } from "@tolgee/vue"
import { FormatIcu } from "@tolgee/format-icu"

export const defaultLanguage = 'nl-BE'

export const tolgee = Tolgee()
  .use(DevTools()) // Allows us to fetch translations from Tolgee API and Edit then -> Automaticaly removed in production
  .use(BackendFetch({prefix: 'https://cdn.tolg.ee/52d35785ff6d2ac0bde6e16d6a2a3976'})) // CDN Translations
  .use(FormatIcu()) // Allows formatting e.g. 'Hello {name}' -> f('Hello {name}', {name: 'John'})
  .use(LanguageStorage()) // Persists language preference in localStorage
  .init({
    defaultLanguage, // Default language (changed from 'language' to 'defaultLanguage' for LanguageStorage)
    availableLanguages: ['nl-BE', 'en', 'fr'], // Available languages for validation
    apiUrl: import.meta.env.VITE_TOLGEE_API_URL, // for production
    apiKey: import.meta.env.VITE_TOLGEE_API_KEY, // for production
  })
